export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: 7,
  boxShadow: 24,
  p: 2,
};

export const ButtonStyle = {
  height: 45,
  color: "white",
  fontWeight: "bold",
};
